import { Section } from "@mittwald/flow-remote-react-components";
import { Suspense } from "react";
import { PageSpeedOptimizer } from "../components/PageSpeedOptimizer.tsx";
import { PageSpeedOptimizerSkeleton } from "../components/PageSpeedOptimizerSkeleton.tsx";
import { useConfig } from "@mittwald/ext-bridge/react";
import { useProject } from "../hooks/useProject.ts";

export const PageSpeedEditor = () => {
  const config = useConfig();

  const appInstallationId = config.appInstallationId;
  if (!appInstallationId) {
    throw new Error("appInstallationId is not defined");
  }

  const projectId = config.projectId;
  if (!projectId) {
    throw new Error("projectId is not defined");
  }

  const project = useProject(projectId);

  const appInstallation = project.data.appInstallations.find(
    (a) => a.id == appInstallationId,
  );

  if (!appInstallation) {
    throw new Error("app installation not found in project");
  }

  return (
    <Suspense
      fallback={
        <Section>
          <PageSpeedOptimizerSkeleton />
        </Section>
      }
    >
      <PageSpeedOptimizer />
    </Suspense>
  );
};
